/**
 * Firebase client config for Chat push notifications
 * Uses REACT_APP_FIREBASE_* env vars from .env
 */

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, Messaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDJ-SrtMAMLUCMWMI8HKnMLUg6V8zojB7s',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'vitreous-chat.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'vitreous-chat',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'vitreous-chat.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '597720787738',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:597720787738:web:de110eb995fffdff999aa3',
};

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

export function getFirebaseApp(): FirebaseApp | null {
  if (!firebaseConfig.apiKey) return null;
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
}

export function getFirebaseMessaging(): Messaging | null {
  if (!getFirebaseApp()) return null;
  if (!messaging && typeof window !== 'undefined') {
    try {
      messaging = getMessaging(getFirebaseApp()!);
    } catch {
      messaging = null;
    }
  }
  return messaging;
}

export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'denied';
  }
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  return Notification.requestPermission();
}

/**
 * Get FCM token for web push. Requires:
 * - Firebase web config in env
 * - firebase-messaging-sw.js in public/ with VAPID key
 * - HTTPS (or localhost for dev)
 */
export async function getFCMToken(): Promise<string | null> {
  const supported = await isSupported();
  if (!supported) return null;

  const msg = getFirebaseMessaging();
  if (!msg) return null;

  try {
    // VAPID key from Firebase Console → Project settings → Cloud Messaging → Web Push certificates
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
    const token = await getToken(msg, vapidKey ? { vapidKey } : undefined);
    return token || null;
  } catch (err) {
    console.warn('[Firebase] getToken failed:', err);
    return null;
  }
}
